module.exports = __webpack_public_path__ + "img/header.c4356dd8.png";